export default class Product {
  static async get(handle) {
    if (!handle) return false;

    const res = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
    const product = await res.json();

    return product;
  }
}
